/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectItemSubmittalQuery } from '../../models/get-project-item-submittal-query';
import { GetProjectItemSubmittalQueryResult } from '../../models/get-project-item-submittal-query-result';

export interface ApiProjectItemSubmittalsGetProjectItemSubmittalPost$Params {
  
    /**
     * The query to retrieve a project item submittal.
     */
    body?: GetProjectItemSubmittalQuery
}

export function apiProjectItemSubmittalsGetProjectItemSubmittalPost(http: HttpClient, rootUrl: string, params?: ApiProjectItemSubmittalsGetProjectItemSubmittalPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemSubmittalQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemSubmittalsGetProjectItemSubmittalPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectItemSubmittalQueryResult>;
    })
  );
}

apiProjectItemSubmittalsGetProjectItemSubmittalPost.PATH = '/api/ProjectItemSubmittals/GetProjectItemSubmittal';
